import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';

import { getProducts, getPriceById, createCheckoutSession, createPortalSession } from "../Services/API/stripe";
import { getAllCustomers } from "../Services/API/customer";
import { sendPurchaseLink } from "../Services/API/email";
import CorelifeLogo from "../Assets/CorelifeLogo.png";

export default function Customers() {
    let { token } = useParams();
    const [customers, setCustomers] = useState();
    const [customer, setCustomer] = useState();
    const [open, setOpen] = React.useState(false);

    useEffect(() => {
        async function listAllCustomers (){
            const res = await getAllCustomers();
            setCustomers(res);
        }
        listAllCustomers();
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    const selfManageClick = async() => {
        const portalSessionRes = await createPortalSession(customer.StripeCustomerId);
        console.log(portalSessionRes);
        window.open(portalSessionRes.session.url, "_blank", "noreferrer");
    };
    const selectCustomer = async (index) => {
        await setCustomer(customers[index])
        setOpen(true);
    }
    const sendEmail = async() => {
        await sendPurchaseLink(customer.CustomerId, customer.StripeCustomerId, customer.Email);
        setOpen(false);
    };



  return (
    
    <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
            {"Send Purchase Email?"}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    By clicking SEND button, purchase url would be sent to your email account.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={sendEmail} autoFocus>
                Send
            </Button>
            </DialogActions>
        </Dialog>
        <Box component="img" src={CorelifeLogo} sx={{  width: "150px", margin: "20px 0px 10px 30px", display: { sm: 'block', xs: 'none' } }}>
        </Box>
        
        <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
                <Typography sx={{ mt: 4, mb: 2, ml:10, mr:10 }} variant="h5" component="div">
                    Patient List
                </Typography>
            </Grid>
            <Grid item xs={2} md={2}>
            </Grid>
            <Grid item xs={2} md={2}>
            </Grid>
            <Grid item xs={2} md={2}>
                <TextField id="standard-basic" label="Search" variant="standard" />
            </Grid>
        </Grid>
        <Grid container spacing={2}>
            <Grid item xs={2} md={2}>
                <Typography sx={{ pt:3,pl:2, textAlign:"center" }} variant="h6" component="div">
                    Username
                </Typography>
            </Grid>
            <Grid item xs={2} md={2}>
                <Typography sx={{ pt:3,pl:2, textAlign:"center" }} variant="h6" component="div">
                    First Name
                </Typography>
            </Grid>
            <Grid item xs={2} md={2}>
                <Typography sx={{ pt:3,pl:2, textAlign:"center" }} variant="h6" component="div">
                    Last Name
                </Typography>
            </Grid>
            <Grid item xs={2} md={2}>
                <Typography sx={{ pt:3,pl:2, textAlign:"center" }} variant="h6" component="div">
                    Customer ID
                </Typography>
            </Grid>
            <Grid item xs={2} md={2}>
                <Typography sx={{ pt:3,pl:2, textAlign:"center" }} variant="h6" component="div">
                    Email
                </Typography>
            </Grid>
        </Grid>
        
        {
            customers && (
                customers.map(
                    (c, index) =>c.StripeCustomerId && (
                        <Box>
                            <Divider></Divider>
                            <Grid container spacing={2}>
                                <Grid item xs={2} md={2}>
                                    <Typography sx={{ pt:2,pl:2,pb:2, textAlign:"center" }} variant="h6" component="div">
                                        {c.UserName}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} md={2}>
                                    <Typography sx={{ pt:2,pl:2,pb:2, textAlign:"center" }} variant="h6" component="div">
                                        {c.FirstName}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} md={2}>
                                    <Typography sx={{ pt:2,pl:2,pb:2, textAlign:"center" }} variant="h6" component="div">
                                        {c.LastName}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} md={2}>
                                    <Typography sx={{ pt:2,pl:2,pb:2, textAlign:"center" }} variant="h6" component="div">
                                        {c.CustomerId}
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} md={2}>
                                    <Typography sx={{ pt:2,pl:2,pb:2, textAlign:"center" }} variant="h6" component="div">
                                        {c.Email}
                                    </Typography>
                                </Grid>
                                
                                <Grid item xs={2} md={2}>
                                    <Box sx={{ pt:2,pl:2,pb:2, textAlign:"center" }}>
                                        <Button  variant="contained" onClick={()=>{selectCustomer(index)}}>Send Purchase Link</Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                        

                    )
                )
            )
        }
    </Box>
  );
}
